import React from 'react';
import {MDXRenderer} from 'gatsby-plugin-mdx';
import {graphql} from 'gatsby';
import SEO from '../../components/Seo';
import Img from 'gatsby-image';
import BreadCrumb from '../../components/Breadcrumb';

import styles from './styles.module.css';

const Page = ({data, location}) => {
  const {mdx} = data;
  const {frontmatter} = mdx;
  const {title, description, isHome, image} = frontmatter;
  return (
    <>
      <SEO
        title={title}
        description={
          description && description !== '' ? description : mdx.excerpt
        }
      />
      {!isHome && <BreadCrumb location={location} title={title} />}
      <div className={styles.page}>
        {image && (
          <Img className={styles.img} fluid={image.childImageSharp.fluid} />
        )}
        {!isHome && <h1>{title}</h1>}
        <div className={styles.page__description}>
          <MDXRenderer>{mdx.body}</MDXRenderer>
        </div>
      </div>
    </>
  );
};

export default Page;

export const query = graphql`
  query PageQuery($slug: String!) {
    mdx(fields: {slug: {eq: $slug}}) {
      frontmatter {
        id
        title
        description
        isHome
        image {
          publicURL
          childImageSharp {
            fluid(maxWidth: 700, maxHeight: 600) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
      body
      excerpt(pruneLength: 200, truncate: true)
    }
  }
`;
